import type { ModalHeaderModel } from "../../type/modal";
import { useI18n } from "../../utils/translate/i18n/useI18n";

export const ModalHeader: React.FC<ModalHeaderModel> = ({ title, onClose }) => {
  const { t } = useI18n();
  return (
    <div className="modal-header">
      <h4 className="modal-title">{title}</h4>

      {onClose && (
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label={t("Zamknij")}
        >
          &times;
        </button>
      )}
    </div>
  );
};
